import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-status-selector-option',
  templateUrl: './status-selector-option.component.html',
  styleUrls: ['./status-selector-option.component.scss'],
  standalone: false,
})
export class StatusSelectorOptionComponent {
  @Input() label: string;
  @Input() value: string;
  @Input() isSelected: boolean;
  @Input() isFavourite = false;
  @Input() isFavouriteable? = true;
  @Output() selectEvent = new EventEmitter<string>();
  @Output() favouriteEvent? = new EventEmitter<string>();
}
